'use client';
import { BreadcrumbPage } from '../../../components/breadcrumb';
import type { HeaderProps } from './header.props';

export const Breadcrumbs = ({
  title,
}: Pick<HeaderProps, 'locale' | 'title' | 'parents'>) => {
  return (
    <nav
      className='flex min-w-0 items-center md:hidden'
      aria-label='breadcrumb'
    >
      <ol className='flex min-w-0 items-center gap-1.5 whitespace-nowrap text-sm text-muted-foreground sm:gap-2.5'>
        <BreadcrumbPage className='truncate text-base font-medium md:text-sm md:font-normal'>
          {title}
        </BreadcrumbPage>
      </ol>
    </nav>
  );
};
